/**
 * Header Search Products JS
 *
 * @since   1.0.0
 * @package premier
 */
(function($) {
    // Hook for when elementor front end is loaded
    $(window).on('elementor/frontend/init', function() {
        //hook name is 'frontend/element_ready/{widget-name}.{skin}
        //$scope is a jquery wrapped parent element
        elementorFrontend.hooks.addAction('frontend/element_ready/header.default', function($scope) {

			var headerSearchForm = document.querySelector('.search-box form.elementor-search-form');
			var productsInput = '<input type="hidden" name="post_type" value="product">';
			headerSearchForm.insertAdjacentHTML('beforeend', productsInput);

        });
    });

})(jQuery);
